import { Spin } from "antd";
import { inject, observer } from "mobx-react";

import InfiniteScroll from "react-infinite-scroller";
import React from "react";
import _ from "lodash";
import moment from "moment";

@inject("store")
@observer
class UserUnDeleted extends React.Component {
  loadMoreUnDeletedMessages = () => {
    const {
      store: {
        DeletedMessagesStore: {
          userUnDeletedLoading,
          fetchUserUnDeletedMessages,
        },
        ProfileStore: { userId },
      },
    } = this.props;
    if (userUnDeletedLoading) {
      return;
    }
    fetchUserUnDeletedMessages(userId);
  };

  render() {
    const {
      store: {
        DeletedMessagesStore: {
          userUnDeletedMessages,
          userUnDeletedLoading,
          groupNames,
          dmNames,
          userUnDeletedSkip,
          userUnDeletedTotal,
        },
      },
    } = this.props;
    return userUnDeletedMessages.length ? (
      <div className="group-chat">
        <div style={{ height: "calc(100vh - 220px)", overflow: "auto" }}>
          <InfiniteScroll
            loadMore={this.loadMoreUnDeletedMessages}
            useWindow={false}
            hasMore={userUnDeletedSkip < userUnDeletedTotal}
          >
            {userUnDeletedMessages.map((message, index) => {
              return message.userId ? (
                <div key={message.messageId}>
                  <div className="flag-container">
                    <div className="flag-upper">
                      <div className="flag-name-container">
                        <div>
                          <span className="flag-name">{message.sender}</span>
                        </div>
                      </div>
                      <div className="flag-time">
                        {moment(message.createdAt).calendar()}
                      </div>
                    </div>
                    {message.channelType === "GROUP" ? (
                      <div className="info-icon-container">
                        <div className="flag-group">
                          {`in ${groupNames.get(message.channelId)}`}
                        </div>
                      </div>
                    ) : null}
                    {message.channelType === "DIRECT" ? (
                      <div className="info-icon-container">
                        <div className="flag-group">
                          {`in ${dmNames.get(message.channelId)}`}
                        </div>
                      </div>
                    ) : null}
                    <div className="flag-middle">
                      {message.type === "text" ? (
                        <div className="flag-message-container">
                          <div className="heading">{message.text}</div>
                        </div>
                      ) : message.type === "img" || message.type === "gif" ? (
                        <img
                          src={message.imgUrl}
                          alt=""
                          height="60"
                          width="60"
                        />
                      ) : (
                        <span className="heading"></span>
                      )}
                      <br />

                      <span className="subHeading">
                        {`UnDeleted by ${message.deletedBy}`}
                      </span>
                    </div>
                  </div>
                  <hr className="horizontal-tag" />
                </div>
              ) : null;
            })}
            {userUnDeletedLoading && (
              <div className="loading-alert-members">
                <Spin />
              </div>
            )}
          </InfiniteScroll>
        </div>
      </div>
    ) : userUnDeletedLoading ? (
      <div className="loading-alert-members">
        <Spin />
      </div>
    ) : null;
  }
}
export default UserUnDeleted;
